// Feature-specific marker used by backend email/PDF sanitizers to keep only
// first-party rich-text images.
export const RICH_TEXT_EDITOR_FILE_ID_ATTRIBUTE =
  'data-rich-text-editor-file-id'

// Protects email payloads and PDF exports from image-heavy rich text.
export const MAX_RICH_TEXT_IMAGES = 20

export const DEFAULT_ALLOWED_MIME_TYPES = new Set([
  'image/avif',
  'image/gif',
  'image/jpeg',
  'image/png',
  'image/webp',
])

export const PDF_UNSUPPORTED_MIME_TYPES = new Set(['image/avif', 'image/webp'])

export const MAX_IMAGE_UPLOAD_FILE_SIZE_BYTES = 10 * 1024 * 1024

export const IMAGE_TYPE_LABELS: Record<string, string> = {
  'image/avif': 'AVIF',
  'image/gif': 'GIF',
  'image/jpeg': 'JPEG',
  'image/png': 'PNG',
  'image/webp': 'WebP',
}
